import styled from 'styled-components';

export const StyledHero = styled.div`
  position: relative;
  /* background-color: var(--color-header); */
  height: 100%;
  /* padding-bottom: calc(var(--header-height) * 2); */
  transition: background-color var(--theme-transition-duration), color var(--theme-transition-duration);
  display: flex;
  grid-template-columns: 1fr 424px;
  align-items: center;
  justify-content: space-between;

  &:first-child {
    flex: 0 0;
  }

  &:last-child {
    flex: 0 0;
  }
`;
